import { http } from './config'

export default {
  getPalletTypeSetups: () => {
    return http.get('pallet_type_setups')
  },

  getPalletTypeSetupById: (palletTypeSetupId) => {
    return http.get('pallet_type_setups/' + palletTypeSetupId)
  },

  getPalletTypeSetupByPalletTypeAndLocality: (params) => {
    return http.get(`pallet_type_setups/by_pallet_type_and_locality/?pallet_type_id=${params.pallet_type_id}&locality_id=${params.locality_id}`)
  },

  createPalletTypeSetup: (palletTypeSetupParams) => {
    return http.post('pallet_type_setups', {
      pallet_type_id: palletTypeSetupParams.pallet_type_id,
      locality_id: palletTypeSetupParams.locality_id,
      quantity_limitation: palletTypeSetupParams.quantity_limitation,
      limit_quantity: palletTypeSetupParams.limit_quantity,
      minimal_cubage: palletTypeSetupParams.minimal_cubage,
      maximal_cubage: palletTypeSetupParams.maximal_cubage,
      specific_products: palletTypeSetupParams.specific_products,
      minimal_vehicle_percentage: palletTypeSetupParams.minimal_vehicle_percentage,
    })
  },

  updatePalletTypeSetup: (palletTypeSetupParams) => {
    return http.put('pallet_type_setups/' + palletTypeSetupParams.id, {
      quantity_limitation: palletTypeSetupParams.quantity_limitation,
      limit_quantity: palletTypeSetupParams.limit_quantity,
      minimal_cubage: palletTypeSetupParams.minimal_cubage,
      maximal_cubage: palletTypeSetupParams.maximal_cubage,
      specific_products: palletTypeSetupParams.specific_products,
      minimal_vehicle_percentage: palletTypeSetupParams.minimal_vehicle_percentage,
    })
  },
}
